module.exports = __webpack_public_path__ + "img/monitor_2.48c988a8.png";